import { inteligenciaUrbana } from "@/mocks/dashboard";

export default function InteligenciaUrbana() {
  return (
    <div className="bg-white rounded-card border border-background-200 p-5">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
          <i className="ri-brain-line text-accent-600 text-sm"></i>
        </div>
        <h3 className="text-sm font-semibold text-foreground-900 font-heading">Inteligência Urbana</h3>
      </div>
      <div className="space-y-3">
        {inteligenciaUrbana.map((insight) => (
          <div
            key={insight.id}
            className="rounded-lg border border-background-200 p-3 hover:border-background-300 transition-colors cursor-pointer"
          >
            <div className="flex items-start gap-2.5">
              <div className="w-6 h-6 rounded bg-accent-50 flex items-center justify-center shrink-0 mt-0.5">
                <i className={`${insight.icone} text-accent-600 text-xs`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-foreground-500 font-medium mb-0.5">{insight.titulo}</p>
                <p className="text-sm font-semibold text-foreground-900">{insight.valor}</p>
                <p className="text-xs text-foreground-600 mt-1 leading-relaxed">{insight.descricao}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}